export default function reducer(
  state = {
    activateChannelList: '',
  },
  action
) {
  switch (action.type) {
    case 'GET_ACTIVATE_CHANNEL_LIST_STARTED': {
      return { ...state, changingStatus: 'ongoing' };
    }
    case 'GET_ACTIVATE_CHANNEL_LIST_SUCCESS': {
      return {
        ...state,
        changingStatus: 'success',
        activateChannelList: action.payload,
      };
    }
    case 'GET_ACTIVATE_CHANNEL_LIST_FAILED': {
      return {
        ...state,
        changingStatus: 'failed',
        activateChannelList: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
